// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1wVMn","bigColWidth":"Table_bigColWidth__3Av3g","biggerColWidth":"Table_biggerColWidth__3yJn2","row":"Table_row__1WuDv","col":"Table_col__3BOej"};